import { useCallback, useMemo, useState } from "react";
import Modal from "../../../components/modal";
import moment from "moment";
import Swal from "sweetalert2";
import axios from "axios";
import { API_URL } from "../../../utils/constant";
import SalesBillVariantPosModel from "./sales_variant_model";


const ClaimModal = ({ show, onClose, bill, onSubmit }) => {
    const [reason, setReason] = useState('');
    const [claimType, setClaimType] = useState('exchange'); // 'exchange' or 'refund'
    const [modeOfPayment, setModeOfPayment] = useState('cash');
    const [returnAmount, setReturnAmount] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectedProductVariant, setSelectedProductVariant] = useState(null);

    const [selectedSerial, setSelectedSerial] = useState({});
    const [variantProduct, setVariantProduct] = useState([]);
    const [showVariantModel, setshowVariantModel] = useState(false);
    const purchaseDate = moment(bill?.createdAt);
    const currentDate = moment();
    const daysDifference = currentDate.diff(purchaseDate, 'days');



    const [selectedOldSerials, setSelectedOldSerials] = useState([]);
    const [newVariants, setNewVariants] = useState([]);

    const [searchText, setSearchText] = useState("");
    const [searchResults, setSearchResults] = useState([]);

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showVariantModal, setShowVariantModal] = useState(false);

    /* =======================
       FLATTEN OLD SERIALS
    ========================*/
    const allOldSerials = useMemo(() => {
        if (!bill?.product_data) return [];
        return bill.product_data.flatMap((p) =>
            p.serial_nos.map((s) => ({
                product_id: p.product_id,
                product_name: p.product_name,
                price: Number(p.price),
                gst: p.gst,
                gst_included: p.gst_included,
                variant_id: s.variant_id,
                serial_no: s.serial_no,
            }))
        );
    }, [bill]);

    /* =======================
       SELECT OLD SERIAL
    ========================*/
    const toggleOldSerial = (serial) => {
        setSelectedOldSerials((prev) => {
            const exists = prev.find((s) => s.variant_id === serial.variant_id);
            if (exists) return prev.filter((s) => s.variant_id !== serial.variant_id);
            return [...prev, serial];
        });
        setNewVariants([]);
    };

    /* =======================
       SEARCH PRODUCT
    ========================*/
    const searchProduct = async () => {
        if (!searchText.trim()) return;

        const company = JSON.parse(localStorage.getItem("company"));
        const companyId = company?.company?.id;

        try {
            const res = await axios.get(
                `${API_URL}/pos/products/${companyId}/search?q=${encodeURIComponent(
                    searchText
                )}`
            );
            if (res.data.success) setSearchResults(res.data.data);
        } catch (error) {
            console.error(error);
        }
    };

    /* =======================
       ADD OR REMOVE NEW VARIANT
    ========================*/
    const handleAddVariant = ({ product, variant_id, serial_no, remove }) => {

        console.log('proudt data', product);
        if (remove) {
            setNewVariants((prev) =>
                prev.filter((v) => v.variant_id !== variant_id)
            );
            return;
        }

        if (newVariants.length >= selectedOldSerials.length) {
            alert("Cannot add more new items than selected old serials");
            return;
        }

        setNewVariants((prev) => [
            ...prev,
            {
                product_id: product.parent_product_id,
                product_name: product.name,
                price: Number(product.sale_cost),
                gst: product.gst || "12.00",
                gst_included: true,
                serial_no,
                variant_id,
            },
        ]);

        console.log('resjpoasndf a', newVariants);
    };

    /* =======================
       PRICE DIFFERENCE
    ========================*/
    const oldTotal = selectedOldSerials.reduce((s, i) => s + i.price, 0);
    const newTotal = newVariants.reduce((s, i) => s + i.price, 0);
    const diff = newTotal - oldTotal;

    /* =======================
       BUILD FINAL product_data
    ========================*/
    const buildFinalProductData = () => {
        const remainingOld = allOldSerials.filter(
            o => !selectedOldSerials.some(s => s.variant_id === o.variant_id)
        );

        const finalItems = [...remainingOld, ...newVariants];

        const grouped = {};

        finalItems.forEach(item => {

            console.log('product data', item);
            const key = `${item.product_name}`;

            if (!grouped[key]) {
                grouped[key] = {
                    product_id: item.product_id,
                    product_name: item.product_name,
                    gst: item.gst,
                    gst_included: item.gst_included,
                    price: item.price,          // unit price
                    qty: 0,
                    amount: 0,
                    serial_nos: []
                };
            }

            grouped[key].qty += 1;
            grouped[key].amount += item.price;
            grouped[key].serial_nos.push({
                serial_no: item.serial_no,
                variant_id: item.variant_id
            });
        });

        return Object.values(grouped);
    };

    /* =======================
       CONFIRM
    ========================*/
    const confirmExchange = async () => {
        const company = JSON.parse(localStorage.getItem("company"));
        const companyId = company?.company?.id;

        const payload = {
            sale_bill_id: bill.id,
            product_data: buildFinalProductData(),

            // 👇 OLD VARIANTS BEING EXCHANGED
            removed_variants: selectedOldSerials.map(s => ({
                variant_id: s.variant_id,
                serial_no: s.serial_no
            })),

            // (optional but recommended)
            price_difference: newVariants.reduce((s, i) => s + i.price, 0) -
                selectedOldSerials.reduce((s, i) => s + i.price, 0)
        };

        console.log("Exchange Payload", payload);
        try {
            await axios.post(`${API_URL}/pos/relocate/bill/${companyId}`, payload);
            alert("Exchange completed");
            window.location.reload();
            onClose();
        } catch (error) {
            console.error(error);
            alert("Something went wrong!");
        }
    };


    const handleSubmit = async () => {
        if (!reason.trim()) {
            Swal.fire('Error!', 'Please enter a reason for the claim.', 'error');
            return;
        }

        setLoading(true);
        try {
            await onSubmit({
                variants_details: selectedOldSerials.map(s => ({
                    variant_id: s.variant_id,
                    serial_no: s.serial_no
                })),
                bill_no: bill.id,
                reason: reason,
                type: claimType,
                mode_of_payment: modeOfPayment,
                amount: returnAmount || 0,
            });
            handleReset();
        } finally {
            setLoading(false);
        }
    };

    const handleProductSerialSelect = useCallback(async (productIdx, product, serial) => {
        setSelectedSerial({ product, serial: serial.variant_id, product_key: productIdx });
        setSelectedProductVariant(null);
        try {
            const company = JSON.parse(localStorage.getItem('company'));
            const companyId = company?.company?.id;
            const response = await axios.get(`${API_URL}/pos/products/${companyId}/variant/${serial.variant_id}`);
            if (response.data.success) {
                setVariantProduct(response.data.data);
            }
        } catch (err) {
            setVariantProduct([]);
        }
    }, []);

    const handleReset = () => {
        setReason('');
        setClaimType('exchange');
        setModeOfPayment('cash');
        setSelectedProduct(null);
        setSelectedProductVariant(null);
        setSelectedSerial({});
    };

    const handleModelclose = () => {
        setshowVariantModel(false);
        setSelectedProduct([]);
    }

    const handleSelectProduct = ({ product, variant_id, serial_no }) => {
        setSelectedProductVariant({ product, qty: 1, serial_nos: [{ variant_id, serial_no }] });
    };



    const handleProductVariant = (product, idx) => {
        setSelectedProduct(product);
        setshowVariantModel(true);
    }

    return (
        <>
            <Modal show={show} onClose={() => { handleReset(); onClose(); }} heading="Process Claim" size="lg">
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label"><strong>Bill No:</strong></label>
                            <p>{bill?.bill_no}</p>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><strong>Purchase Date:</strong></label>
                            <p>{purchaseDate.format('DD-MM-YYYY')}</p>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><strong>Days Since Purchase:</strong></label>
                            <p className={daysDifference > 30 ? 'text-danger fw-bold' : 'text-success'}>
                                {daysDifference} days {daysDifference > 30 ? '(Exceeded 30 days)' : '(Within warranty period)'}
                            </p>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label"><strong>Customer:</strong></label>
                            <p>{bill?.Customer?.name || 'Walk-in Customer'}</p>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><strong>Total Amount:</strong></label>
                            <p>₹{bill?.total?.toFixed(2)}</p>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><strong>Products:</strong></label>
                            <div style={{ maxHeight: '80px', overflowY: 'auto' }}>
                                {bill?.product_data?.map((p, i) => (
                                    <small key={i} className="d-block">
                                        {p.product_name} - ₹{p.amount}
                                    </small>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="mb-3">
                            <label className="form-label"><strong>Select Product</strong></label><br />
                            {allOldSerials.map((s) => (
                                <button
                                    key={s.variant_id}
                                    className={`btn me-2 mb-2 ${selectedOldSerials.some((x) => x.variant_id === s.variant_id)
                                        ? "btn-danger"
                                        : "btn-outline-secondary"
                                        }`}
                                    onClick={() => toggleOldSerial(s)}
                                >
                                    {s.product_name}
                                    <br />
                                    <small>{s.serial_no}</small>
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="mb-3">
                            <label className="form-label"><strong>Claim Reason:</strong></label>
                            <textarea
                                className="form-control"
                                placeholder="Enter reason for claim (e.g., defect, size issue, color mismatch)..."
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                rows="3"
                            />
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label"><strong>Claim Type:</strong></label>
                            <div className="form-check">
                                <input
                                    type="radio"
                                    className="form-check-input"
                                    id="exchange"
                                    value="exchange"
                                    checked={claimType === 'exchange'}
                                    style={{ borderRadius: '2px' }}
                                    onChange={(e) => setClaimType(e.target.value)}
                                />
                                <label className="form-check-label" htmlFor="exchange">
                                    Exchange for Different Product
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    id="refund"
                                    value="refund"
                                    style={{ borderRadius: '2px' }}
                                    checked={claimType === 'refund'}
                                    onChange={(e) => setClaimType(e.target.value)}
                                />
                                <label className="form-check-label" htmlFor="refund">
                                    Refund Money Back
                                </label>
                            </div>
                        </div>
                    </div>

                    {claimType === 'exchange' && (
                        <>
                            {selectedOldSerials.length > 0 && (
                                <>
                                    <hr />
                                    <h6>
                                        Add New Product ({newVariants.length}/{selectedOldSerials.length})
                                    </h6>

                                    <div className="input-group mb-3">
                                        <input
                                            className="form-control"
                                            placeholder="Search product"
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                        <button className="btn btn-primary" onClick={searchProduct}>
                                            Search
                                        </button>
                                    </div>

                                    <div className="row">
                                        {searchResults.map((prod) => (
                                            <div className="col-4 mb-3" key={prod.id}>
                                                <div
                                                    className="card p-2 text-center"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => {
                                                        setSelectedProduct(prod);
                                                        setShowVariantModal(true);
                                                    }}
                                                >
                                                    <img
                                                        src={`${API_URL}/${prod.product_image}`}
                                                        alt={prod.name}
                                                        className="card-img-top mx-auto mt-3"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = '../../logo.png'; // fallback logo on load error
                                                        }}
                                                        style={{ width: "100%", height: 100, objectFit: 'contain', }}
                                                    />
                                                    <p className="mb-0">{prod.name}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {newVariants.length > 0 && (
                                        <>
                                            <hr />
                                            <h6>
                                                New Selected Products ({newVariants.length}/{selectedOldSerials.length})
                                            </h6>

                                            <table className="table table-bordered align-middle">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Product</th>
                                                        <th>Serial</th>
                                                        <th>Price</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {newVariants.map((item, index) => (
                                                        <tr key={item.variant_id}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.product_name}</td>
                                                            <td>{item.serial_no}</td>
                                                            <td>₹{item.price}</td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() =>
                                                                        handleAddVariant({
                                                                            variant_id: item.variant_id,
                                                                            remove: true,
                                                                        })
                                                                    }
                                                                >
                                                                    Remove
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </>
                                    )}
                                </>
                            )}

                            {/* PRICE */}
                            {selectedOldSerials.length > 0 && (
                                <>
                                    {diff > 0 && <div className="alert alert-warning">Exchange Product Cost ₹{oldTotal} and selected New ₹{newTotal} - Add ₹{diff}</div>}
                                    {diff < 0 && (
                                        <div className="alert alert-info">Exchange Product Cost ₹{oldTotal} and selected New ₹{newTotal} -  Return ₹{Math.abs(diff)}</div>
                                    )}
                                    {diff === 0 && <div className="alert alert-success">No Price difference</div>}
                                </>
                            )}

                            <div className="d-flex justify-content-end gap-2 mt-3">

                                <button type="button" className="btn btn-secondary" onClick={() => {
                                    setNewVariants([]);
                                    onClose();
                                }}>Close</button>


                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={newVariants.length === 0}
                                    onClick={async () => {
                                        if (!reason.trim()) {
                                            Swal.fire('Error!', 'Please enter a reason for the claim.', 'error');
                                            return;
                                        }
                                        const company = JSON.parse(localStorage.getItem("company"));
                                        const companyId = company?.company?.id;

                                        const payload = {
                                            sale_bill_id: bill.id,
                                            product_data: buildFinalProductData(),

                                            // 👇 OLD VARIANTS BEING EXCHANGED
                                            removed_variants: selectedOldSerials.map(s => ({
                                                variant_id: s.variant_id,
                                                serial_no: s.serial_no
                                            })),

                                            // (optional but recommended)
                                            price_difference: newVariants.reduce((s, i) => s + i.price, 0) -
                                                selectedOldSerials.reduce((s, i) => s + i.price, 0)
                                        };

                                        console.log("Exchange Payload", payload);
                                        try {
                                            await axios.post(`${API_URL}/pos/relocate/bill/${companyId}`, payload);
                                            handleSubmit();
                                        } catch (error) {
                                            console.error(error);
                                            Swal.fire('Error!', 'Error processing claim.', 'error');
                                        }
                                        try {
                                            // const company = JSON.parse(localStorage.getItem('company'));
                                            // const companyId = company?.company?.id;
                                            // const payload = {
                                            //     sale_bill_id: bill.id,
                                            //     old_variant_id: selectedSerial.serial,
                                            //     new_product: selectedProductVariant,
                                            //     product_key: selectedSerial.product_key
                                            // };
                                            // await axios.post(`${API_URL}/pos/relocate/bill/${companyId}`, payload);


                                            // alert('Re-allocation successful!');
                                            
                                        } catch (err) {
                                            alert('Re-allocation failed!');
                                        }
                                    }}
                                // onClick={async () => {
                                //     // Call API with selectedSerial.variant_id and selectedProductVariant
                                //     try {
                                //         const company = JSON.parse(localStorage.getItem('company'));
                                //         const companyId = company?.company?.id;
                                //         const payload = {
                                //             sale_bill_id: bill.id,
                                //             old_variant_id: selectedSerial.serial,
                                //             new_product: selectedProductVariant,
                                //             product_key: selectedSerial.product_key
                                //         };
                                //         await axios.post(`${API_URL}/pos/relocate/bill/${companyId}`, payload);
                                //         alert('Re-allocation successful!');
                                //         onClose();
                                //     } catch (err) {
                                //         alert('Re-allocation failed!');
                                //     }
                                // }}
                                >
                                    Confirm & Exchange
                                </button>
                            </div>
                        </>
                    )}

                    {claimType === 'refund' && (
                        <>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label"><strong>Amount Returned <span className="badge bg-success">(Difference {diff})</span></strong></label>
                                    <input type="number" className="form-control" value={returnAmount} max={Math.abs(diff)} onChange={(e) => setReturnAmount(e.target.value)} /> 
                                </div>
                                <div className="mb-3">
                                    <label className="form-label"><strong>Mode of Payment (Refund):</strong></label>
                                    <select
                                        className="form-select"
                                        value={modeOfPayment}
                                        onChange={(e) => setModeOfPayment(e.target.value)}
                                    >
                                        <option value="Cash">Cash</option>
                                        <option value="Gpay UPI">Gpay UPI</option>
                                        <option value="Phonepe upi">Phonepe upi</option>
                                        <option value="Paytm upi">Paytm upi</option>
                                        <option value="Bharat pay upi">Bharat pay upi</option>
                                        <option value="Debit card">Debit card</option>
                                        <option value="Credit card">Credit card</option>
                                        <option value="Bhim upi">Bhim upi</option>
                                        <option value="Amazon pay upi">Amazon pay upi</option>
                                        <option value="Axis Bank Pos">Axis Bank Pos</option>
                                        <option value="Phonepe - UCO Bank Pos">Phonepe - UCO Bank Pos</option>
                                        <option value="Card">Card</option>
                                        <option value="UPI">UPI</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-12 d-flex gap-2 justify-content-end">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => { handleReset(); onClose(); }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        // onClick={handleSubmit}
                                        onClick={async () => {
                                            if (!returnAmount.trim()) {
                                                Swal.fire('Error!', 'Please enter a Amount to return for the claim.', 'error');
                                                return;
                                            }
                                            if (!reason.trim()) {
                                                Swal.fire('Error!', 'Please enter a reason for the claim.', 'error');
                                                return;
                                            }
                                            try {
                                                const company = JSON.parse(localStorage.getItem('company'));
                                                const companyId = company?.company?.id;
                                                const response = await axios.post(`${API_URL}/bills/sales-bills/restock/${companyId}`, {
                                                    bill_id: bill.id,
                                                    variant_details: selectedOldSerials.map(s => ({
                                                        variant_id: s.variant_id,
                                                        serial_no: s.serial_no
                                                    })),
                                                    amount: returnAmount
                                                });
                                                if (response.data.message == 'Bill cancelled successfully' || response.data.message == 'Variant-wise return processed') {
                                                    handleSubmit();
                                                }
                                            } catch (err) {

                                                console.error(err);
                                            }
                                        }}
                                        disabled={loading}
                                    >
                                        {loading ? 'Processing...' : 'Submit Claim'}
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>


            </Modal>
            <SalesBillVariantPosModel
                show={showVariantModal}
                onClose={() => setShowVariantModal(false)}
                heading="Select Serial"
                initialData={selectedProduct}
                cart={newVariants}
                addCart={handleAddVariant}
            />
        </>
    );
};

export default ClaimModal;